export default __webpack_public_path__ + "static/media/MEINUNGSMEISTER.d741618e.png";